import { ReactElement } from 'react';
import { FieldProps, ErrorMessage, useFormikContext, getIn } from 'formik';
import { FileUploader } from 'react-drag-drop-files';
import classnames from 'classnames';
// import GoodUpload from '../../images/GoodUpload.svg';
import Upload from '../../images/Upload.svg';
import styles from './FilesUpload.module.scss';

interface iProps extends FieldProps {
  title: string;
  isMandatory: boolean;
  fileTypes: [];
  labelContent: string;
  fileSizelimit: string;
  errorFieldName: string;
  handleChange?: () => void;
  handFileSizeError?: () => void;
}

const FilesUploadAccessible = ({ errorFieldName, labelContent, title, isMandatory, fileTypes, fileSizelimit, handleChange, handFileSizeError }: iProps): ReactElement => {
  const { errors, touched }: { errors: any; touched: any; } = useFormikContext();
  const touchedError = getIn(touched, errorFieldName);
  const hasError = getIn(errors, errorFieldName);
  const labelContentUpload = labelContent || 'Drag and drop, or choose files';

  const handleKeyDown = (event: { key: string; preventDefault: () => void; }) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      // Trigger file input when 'Enter' or 'Space' is pressed
      document.getElementsByName('file')[0]!.click();
    }
  };

  return (
    <div
      className={classnames({
        [styles.container]: true,
        [styles.titlePresent]: title,
      })}>
      {title && (
        <div
          className={classnames({
            [styles.title]: true,
            [styles.titleError]: hasError && touchedError,
          })}>
          <span className={styles.titleBold}>{title}</span>
          {!isMandatory && <span className={styles.optional}> ( optional )</span>}
        </div>
      )}
      <div className={styles.selectContainer}>
        <FileUploader id="fileClick" label={labelContentUpload} handleChange={handleChange} name="file" types={fileTypes} maxSize={fileSizelimit} onSizeError={handFileSizeError}>
          <div className={styles.fileUploadContainer} role="button" tabIndex={0} onKeyDown={handleKeyDown}>
            <span className={styles.dropTitle} title={labelContentUpload}>
              {labelContentUpload}
            </span>
            <img src={Upload} alt="Cloud upload button" />
          </div>
        </FileUploader>
      </div>
      <ErrorMessage className={styles.errorMsg} name={errorFieldName} component="span" />
    </div>
  );
};

export default FilesUploadAccessible;
